import { IGoalShowState } from '../../types/app-state'
import { SELECT_TAGS } from '../constants/goal-show'

const initialState: IGoalShowState = {
  selectedTags: []
}

const reducer = (state = initialState, action): IGoalShowState => {
  switch (action.type) {
    case SELECT_TAGS:
      return {
        ...state,
        selectedTags: action.tags
      }
    default:
      return state
  }
}

export { reducer }
